export const DOMAIN_ERROR_CODES = [
    "capability_not_declared",
    "conflict",
    "invalid_request",
    "not_found",
    "stage_composition_not_enabled",
    "unauthorized",
    "unsupported_query",
    "validation_failed",
];
export const SYNC_ERROR_CODES = ["outbox_delivery_failed", "sync_conflict", "sync_terminal_failure"];
export const TRANSPORT_ERROR_CODES = ["connection_lost", "offline", "unavailable"];
class SerializableClientErrorBase extends Error {
    code;
    details;
    constructor(options) {
        super(options.message);
        this.code = options.code;
        this.details = options.details;
    }
    toJSON() {
        return this.details === undefined
            ? { code: this.code, kind: this.kind, message: this.message }
            : { code: this.code, details: this.details, kind: this.kind, message: this.message };
    }
}
export class DomainError extends SerializableClientErrorBase {
    kind = "domain";
    constructor(options) {
        super(options);
    }
}
export class SyncError extends SerializableClientErrorBase {
    kind = "sync";
    constructor(options) {
        super(options);
    }
}
export class TransportError extends SerializableClientErrorBase {
    kind = "transport";
    constructor(options) {
        super(options);
    }
}
//# sourceMappingURL=index.js.map